module.exports = require("react-transition-group");


//////////////////
// WEBPACK FOOTER
// external "react-transition-group"
// module id = 16
// module chunks = 0